import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { currencySelector, settingsLoadingSelector } from '../../store/settings/selectors'
import { getCurrencies } from '../../store/settings/actions'

const CurrencySign = React.memo(() => {
  const dispatch = useDispatch()

  const currencies = useSelector(currencySelector)
  const settingsLoading = useSelector(settingsLoadingSelector)
  const company = useSelector(state => state.company.companyInfo)

  useEffect(() => {
    if (Array.isArray(currencies) && !currencies.length && !settingsLoading) {
      dispatch(getCurrencies())
    }
  }, [currencies, dispatch, settingsLoading])

  const currency = useMemo(() => {
    if (Array.isArray(currencies)) {
      return currencies
        .find((curr) => curr.code === company?.currency || curr.name === company?.currency)?.symbol ?? '';
    }

    return '';
  }, [company.currency, currencies])

  return currency
})

export default CurrencySign;
